
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const MailIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m7.498 9.75 2.927 1.803a3.002 3.002 0 0 0 3.15 0l2.927-1.804"/><rect width="18.008" height="14.006" x="2.996" y="4.997" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" rx="3"/></svg>
  </SvgIcon>
);
